import { BlankSlate } from "../../blank-slate";

export function DataTableBlankSlate() {
	return (
		<div className="absolute inset-0">
			<BlankSlate
				withBorder={false}
				className="pointer-events-none"
			/>
		</div>
	);
}
